import storage from '@/common/storage';

export const generateTabId = () => {
  const sid =  storage.getItem('tabId') || 0;
  const tabId = Number(sid) + 1;
  storage.setItem('tabId', tabId);
  return (Math.random() * 1e18).toString(32) + tabId;
};

export { sleep } from '@/common/utils/functions';
